<div>
  @if (show_overlay()) {
  <div class="fixed inset-0 bg-slate-900 bg-opacity-60 z-10" (click)="closeSidebars()"></div>
  }
  <header class="fixed top-0 left-0 right-0  z-30 flex items-center px-4 h-16 bg-slate-100 border-b border-slate-200">
    <div class="flex flex-row flex-nowrap gap-1 items-center justify-center w-full">
      <div
        class="flex items-center justify-center rounded cursor-pointer aspect-square w-10 h-10 border border-slate-200 bg-slate-50 hover:bg-white text-green-600"
        (click)="toggleLeftSidebar()">
        <i class="fa-solid fa-bars"></i>
      </div>
      <p class="w-full text-center text-green-600 cursor-pointer" (click)="navigateToPage('')">
        {{title()}}
      </p>
      <div
        class="flex items-center justify-center rounded cursor-pointer aspect-square w-10 h-10 border border-slate-200 bg-slate-50 hover:bg-white text-green-600"
        (click)="toggleRightSidebar()">
        <i class="fa-solid fa-bars"></i>
      </div>
    </div>
  </header>
  <aside
    class="fixed top-16 bottom-0 left-0 w-72 transform transition-transform duration-300 z-20 overflow-y-scroll bg-slate-50 border-r border-l-4 border-slate-200 "
    [ngClass]="{'translate-x-0': show_left_sidebar(), '-translate-x-full': !show_left_sidebar()}">
    <div>
      <div class="flex flex-row flex-nowrap gap-1 items-center justify-center h-16 bg-slate-100 border-b border-slate-200">
        <div
          class="flex items-center justify-center rounded cursor-pointer aspect-square w-12 h-12 border border-slate-200 bg-slate-50 hover:bg-white text-pink-600"
          (click)="navigateToPage('')">
          <i class="fa-solid fa-home"></i>
        </div>
        <div
          class="flex items-center justify-center rounded cursor-pointer aspect-square w-12 h-12 border border-slate-200 bg-slate-50 hover:bg-white text-cyan-600"
          (click)="openLink(twitter_url())">
          <i class="fa-brands fa-twitter"></i>
        </div>
        <div
          class="flex items-center justify-center rounded cursor-pointer aspect-square w-12 h-12 border border-slate-200 bg-slate-50 hover:bg-white text-violet-600"
          (click)="openLink(discord_url())">
          <i class="fa-brands fa-discord"></i>
        </div>
      </div>
      <app-menu></app-menu>
    </div>
  </aside>
  <aside
    class="fixed top-16 bottom-0 right-0 w-72 transform transition-transform duration-300 z-20 overflow-y-scroll bg-slate-50 border-l border-slate-200"
    [ngClass]="{'translate-x-0': show_right_sidebar(), 'translate-x-full': !show_right_sidebar(), 'border-l-4': show_right_sidebar() && !is_desktop()}">
    <div>
      <div class="flex flex-row flex-nowrap gap-1 items-center justify-center h-16 bg-slate-100 border-b border-slate-200">
        <div
          class="flex items-center justify-center rounded cursor-pointer aspect-square w-12 h-12 border border-slate-200 bg-slate-50 hover:bg-white text-teal-600"
          (click)="selectTab('account')">
          <i class="fa-solid fa-user"></i>
        </div>
        <div
          class="flex items-center justify-center rounded cursor-pointer aspect-square w-12 h-12 border border-slate-200 bg-slate-50 hover:bg-white text-rose-600"
          (click)="selectTab('chat')">
          <i class="fa-solid fa-comment"></i>
        </div>
        <div
          class="flex items-center justify-center rounded cursor-pointer aspect-square w-12 h-12 border border-slate-200 bg-slate-50 hover:bg-white text-fuchsia-600"
          (click)="selectTab('settings')">
          <i class="fa-solid fa-cog"></i>
        </div>
      </div>
      @if (selected_tab() == 'account') {
      <app-account></app-account>
      }
      @else if (selected_tab() == 'chat') {
      <app-chat></app-chat>
      }
      @else if (selected_tab() == 'settings') {
      <app-settings></app-settings>
      }
    </div>
  </aside>
  <div class="fixed top-16 bottom-0 left-0 right-0 z-0 overflow-y-scroll transition-all duration-300"
    [ngClass]="{'ml-72': show_left_sidebar() && is_desktop(), 'mr-72': show_right_sidebar() && is_desktop(), 'border-l-4': !show_left_sidebar()}">
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>